// Which version of the interface to show (2026-10-04, owner asked for a header switch to compare for a few days):
//   orig  the layout that was live before the redesign (flat 11-item sidebar, two-row KPI header)
//   v1    Maximum density: icon-rail sidebar, a one-screen desk as the home page
//   v2    Context-aware: workspaces, and a home page whose widgets follow the market state and alerts
//   v3    Consolidated tabs: four workspaces with sub-tabs, hotkeys and a Ctrl+K palette; the Dashboard keeps its page
//   v4    Calm: V2's situational logic on V3's navigation, status first, one list of what needs you (UX review 2026-10-04)
// Chosen with the ORIG / V1 / V2 / V3 / V4 buttons in the header, or ?ui=orig|v1|v2|v3|v4 in the address; remembered in this
// browser (localStorage). Switching does not reload the page. Default v3. Old values: classic = orig, new = v3.
// The exact pre-redesign code is also kept in git as the tag gui-classic-2026-10-04.
import { useSyncExternalStore } from 'react'

const KEY = 'sf_ui_mode'
export const UI_MODES = [
  { key: 'orig', label: 'ORIG', title: 'The layout that was live before the 2026-10-04 redesign' },
  { key: 'v1',   label: 'V1',   title: 'Maximum density: icon rail and a one-screen desk' },
  { key: 'v2',   label: 'V2',   title: 'Context-aware: the home page follows market open, closed and incident' },
  { key: 'v3',   label: 'V3',   title: 'Consolidated tabs: four workspaces, sub-tabs, hotkeys, Ctrl+K' },
  { key: 'v4',   label: 'V4',   title: 'Calm: status first, one list of what needs you, details on demand' },
]
const LEGACY = { classic: 'orig', new: 'v3' }
const norm = (v) => LEGACY[v] || (UI_MODES.some(m => m.key === v) ? v : null)

function read() {
  try {
    const fromUrl = norm(new URLSearchParams(window.location.search).get('ui'))
    if (fromUrl) {
      window.localStorage.setItem(KEY, fromUrl)
      return fromUrl
    }
    return norm(window.localStorage.getItem(KEY)) || 'v3'
  } catch {
    return 'v3'   // storage blocked: fall back to the default instead of failing
  }
}

let current = read()
const listeners = new Set()

export function getUiMode() {
  return current
}

export function setUiMode(mode) {
  current = norm(mode) || 'v3'
  try { window.localStorage.setItem(KEY, current) } catch { /* the mode still applies for this page view */ }
  try {
    const url = new URL(window.location.href)
    url.searchParams.set('ui', current)
    window.history.replaceState(window.history.state, '', url)
  } catch { /* address bar update is cosmetic */ }
  listeners.forEach(f => f())
}

export function useUiMode() {
  return useSyncExternalStore(
    (cb) => { listeners.add(cb); return () => listeners.delete(cb) },
    () => current,
  )
}
